<template>
  <MenuWrapper class="mx-2 mt-8">
    <MenuLink v-for="item in elements" :key="item.name" :href="item.href" :icon="item.icon" :newTab="true" :hoverableTitle="!isExpanded">
      {{ item.title }}
    </MenuLink>
  </MenuWrapper>
</template>
<script setup lang="ts">
import { MenuWrapper, MenuLink } from '@/storybook/menu';

defineProps<{ isExpanded: boolean }>();

const elements = [
  {
    title: 'Screen Recorder',
    name: 'screen_recorder',
    href: 'https://zight.com/screen-recorder?utm_source=share_page&utm_medium=sidebar&utm_content=screen_recorder',
    icon: 'general.newRecording',
  },
  {
    title: 'Meeting Recorder',
    name: 'meeting_recorder',
    href: 'https://zight.com/meeting-recorder?utm_source=share_page&utm_medium=sidebar&utm_content=meeting_recorder',
    icon: 'general.users',
  },
  {
    title: 'Request Links',
    name: 'request_video',
    href: 'https://zight.com/request-video?utm_source=share_page&utm_medium=sidebar&utm_content=request_video',
    icon: 'general.requestLinks',
  },
  {
    title: 'Step-by-Step Guides',
    name: 'step_by_step_guides',
    href: 'https://zight.com/sop-generator?utm_source=share_page&utm_medium=sidebar&utm_content=step_by_step_guides',
    icon: 'ai.stepByStepGuide',
  },
  {
    title: 'Video Redaction',
    name: 'video_redaction',
    href: 'https://zight.com/video-redaction?utm_source=share_page&utm_medium=sidebar&utm_content=video_redaction',
    icon: 'general.eyeDisabled',
  },
  {
    title: 'Playbooks',
    name: 'playbooks',
    href: 'https://zight.com/agent?utm_source=share_page&utm_medium=sidebar&utm_content=playbooks',
    icon: 'ai.technicalDocumentation',
  },
];
</script>
